import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

interface DocumentIdItem {
  key: string
  type: "unique" | "item" | "asset"
}

export class DocumentIdOptionsVM extends CommonOptionVM {
  required?: boolean
  read_only?: boolean
  format?: string
  items?: DocumentIdItem[]

  constructor(data: Partial<DocumentIdOptionsVM> = {}) {
    super(data)
    this.required = data.required ?? undefined
    this.read_only = data.read_only ?? undefined
    this.format = data.format ?? undefined
    this.items = data.items ?? undefined
  }

  validateData() {
    const errors: any[] = []
    /**
     * *** ### Check type if right
     * if type is "unique" the key should number|timestamp
     * if type is "item" the key should UUID
     * */
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default DocumentIdOptionsVM
